import React from 'react';
export const MoreTestimonials = () => {
  return <section className="mb-10" data-id="element-225">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-226">
        Meer reacties van deelnemers
      </h2>
      <div className="space-y-4" data-id="element-227">
        {/* Liset's testimonial */}
        <div className="flex items-start" data-id="element-228">
          <div className="flex-shrink-0 mr-3" data-id="element-229">
            <div className="w-12 h-12 bg-blue-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-230">
              L
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-231">
            <div className="flex justify-between mb-1" data-id="element-232">
              <span className="font-bold" data-id="element-233">Liset</span>
              <span className="text-gray-500 text-sm" data-id="element-234">21:29</span>
            </div>
            <p data-id="element-235">Super bedankt. Was boeiend en leerzaam.</p>
          </div>
        </div>
        {/* Linda's testimonial */}
        <div className="flex items-start" data-id="element-236">
          <div className="flex-shrink-0 mr-3" data-id="element-237">
            <div className="w-12 h-12 bg-purple-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-238">
              L
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-239">
            <div className="flex justify-between mb-1" data-id="element-240">
              <span className="font-bold" data-id="element-241">Linda</span>
              <span className="text-gray-500 text-sm" data-id="element-242">21:39</span>
            </div>
            <p data-id="element-243">
              leuk filmpje :-) Zie mezelf en mijn "hondenkleinkids" :)))
              aangenaam verast.
              <br data-id="element-244" />
              Dankjewel voor de masterclass
            </p>
          </div>
        </div>
        {/* Karin and Annemieke testimonials */}
        <div className="flex items-start" data-id="element-245">
          <div className="flex-shrink-0 mr-3" data-id="element-246">
            <div className="w-12 h-12 bg-purple-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-247">
              K
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-248">
            <div className="flex justify-between mb-1" data-id="element-249">
              <span className="font-bold" data-id="element-250">Karin</span>
              <span className="text-gray-500 text-sm" data-id="element-251">21:40</span>
            </div>
            <p data-id="element-252">Heel erg bedankt, het was heel leerzaam</p>
          </div>
        </div>
        <div className="flex items-start" data-id="element-253">
          <div className="flex-shrink-0 mr-3" data-id="element-254">
            <div className="w-12 h-12 bg-blue-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-255">
              A
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-256">
            <div className="flex justify-between mb-1" data-id="element-257">
              <span className="font-bold" data-id="element-258">Annemieke</span>
              <span className="text-gray-500 text-sm" data-id="element-259">21:40</span>
            </div>
            <p data-id="element-260">heel erg bedankt voor de masterclass! groetjes, Annemieke</p>
          </div>
        </div>
        {/* Jessica's testimonial */}
        <div className="flex items-start" data-id="element-261">
          <div className="flex-shrink-0 mr-3" data-id="element-262">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/e2XikCMQaZbQPPWTtN2TFx/Jessica_mail_MCC_2.png" alt="Jessica" className="w-12 h-12 object-cover rounded-md" data-id="element-263" />
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-264">
            <div className="flex justify-between mb-1" data-id="element-265">
              <span className="font-bold" data-id="element-266">Jessica</span>
              <span className="text-gray-500 text-sm" data-id="element-267">aan mij</span>
            </div>
            <p className="mb-2" data-id="element-268">Hi Amee,</p>
            <p className="mb-2" data-id="element-269">Super, het is gelukt. Dankjewel!</p>
            <p className="mb-2" data-id="element-270">
              Ik wilde nog mijn complimenten geven voor de masterclass van
              gisteren. Ik heb menig gratis webinars gevolgd en vond die van jou
              echt wel de beste. Ben benieuwd naar de cursussen!
            </p>
            <p data-id="element-271">Groeten, Jessica</p>
          </div>
        </div>
        {/* Corrie's testimonial */}
        <div className="flex items-start" data-id="element-272">
          <div className="flex-shrink-0 mr-3" data-id="element-273">
            <div className="w-12 h-12 bg-purple-500 rounded-md flex items-center justify-center text-white text-xl font-bold" data-id="element-274">
              C
            </div>
          </div>
          <div className="flex-1 bg-gray-50 p-4 rounded-lg" data-id="element-275">
            <div className="flex justify-between mb-1" data-id="element-276">
              <span className="font-bold" data-id="element-277">Corrie</span>
              <span className="text-gray-500 text-sm" data-id="element-278">21:40</span>
            </div>
            <p data-id="element-279">Bedankt voor je heldere uitleg! Fijne avond</p>
          </div>
        </div>
      </div>
    </section>;
};